export const HOST = process.env.HOST || '';
export const API_HOST = process.env.API_HOST || '';
export const API_ROOT = process.env.API_ROOT || '';
